import localStorage from 'utils/localStorage';

export const getNormalizedLocale = (ownerLocale) => {
  const locale = ownerLocale || localStorage.getLanguage();
  return locale === 'en-US-nonAmericanDates' ? 'en-GB' : locale || 'en-US';
};
